/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {pruneSupportCriteriaNodes} from '../api'

export const useMutationPruneSupportCriteriaNodes = createReactQueryMutationHook('pruneSupportCriteriaNodes', pruneSupportCriteriaNodes)
